import { createClient, SupabaseClient } from "@supabase/supabase-js";

// Polyfill for iOS 17 and earlier
if (!(URL as any).parse) {
  (URL as any).parse = function (url: string, base?: string): URL | null {
    try {
      return new URL(url, base);
    } catch (e) {
      return null;
    }
  };
}

// supabase-js parses the auth callback out of the URL during its own startup and
// then clears window.location.hash, which races React mounting the route. Snapshot
// the params here, before the client is constructed, so pages can still tell how
// the user arrived (recovery link, signup confirmation, expired token, etc).
const callbackHash = typeof window !== "undefined" ? window.location.hash.replace(/^#/, "") : "";
const callbackParams = new URLSearchParams(callbackHash);

export const authCallbackParams = {
  type: callbackParams.get("type"),
  hasAccessToken: callbackParams.has("access_token"),
  error: callbackParams.get("error"),
  errorCode: callbackParams.get("error_code"),
  errorDescription: callbackParams.get("error_description"),
};

const supabaseClient: SupabaseClient = createClient(
  process.env.REACT_APP_SUPABASE_ENDPOINT,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

export default supabaseClient;
